module.exports = __webpack_public_path__ + "img/8.ef09c59b.png";